import type { Section } from '../../../models';
import { METHAMPHETAMINE } from '../../../constants';
import YesAndNo from '../../../../shared/components/Widgets/YesAndNo';
import { FormField, Label } from '@zillow/constellation-10';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function Methamphetamine_v3({ section, setSectionValues }: Props) {
  function onNoKnowledge(): void {
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE]: false,
    });
  }

  function onYesKnowledge(): void {
    setSectionValues({
      [METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE]: true,
    });
  }

  return (
    <FormField
      required
      label={
        <Label>
          Do you know if the property is currently contaminated from the use, storage, or manufacture of
          methamphetamines?
        </Label>
      }
      control={
        <YesAndNo
          yesHandler={onYesKnowledge}
          noHandler={onNoKnowledge}
          yesActive={section.getFieldValue(METHAMPHETAMINE.FIELD_NAME.KNOWLEDGE)}
        />
      }
    />
  );
}

Methamphetamine_v3.description =
  'Asks whether or not the landlord has knowledge of meth production, slight copy change for Utah';

export default Methamphetamine_v3;
